import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DateWithTimezones, DISPLAY_DATE_FORMAT } from '../../../../common';
import { LatestNotification } from '../../../../store/state/monitoring/models';
import { LocalDate } from '../../../../store';

@Component({
  selector: 'ui-monitoring-notifications',
  templateUrl: './monitoring-notifications.component.html',
  styleUrls: ['./monitoring-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitoringNotificationsComponent {
  @Input() notifications: LatestNotification[];
  @Input() isLocalDate = false;
  @Input() displayLocalAndProfileTime = false;
  dateFormat = DISPLAY_DATE_FORMAT;

  getLocalDate(notification: LatestNotification): LocalDate {
    return notification?.actualArrivalTime as LocalDate;
  }

  getDateWithTimezones(notification: LatestNotification): DateWithTimezones {
    return notification?.actualArrivalTime as DateWithTimezones;
  }
}
